/**
 * ACORDE — Nota, la asesora de fragancias (snippets/acorde-nota.liquid).
 *
 * El dibujo y las animaciones son SVG + CSS. Este script solo añade:
 * - el cambio de estado: `nota.estado = 'pensando'` o `nota.setAttribute('estado', 'pensando')`;
 * - un estado pasajero: `nota.decir('escuchando', 900)` y vuelve al anterior;
 * - la mirada que sigue al dedo o al puntero (se apaga si la persona pidió menos movimiento).
 *
 * Estados: reposo · sonriendo · escuchando · pensando · preguntando · riendo · recomendando · lo-siento
 */
const ESTADOS = ['reposo', 'sonriendo', 'escuchando', 'pensando', 'preguntando', 'riendo', 'recomendando', 'lo-siento'];
const QUIETO = window.matchMedia('(prefers-reduced-motion: reduce)');

class AcordeNota extends HTMLElement {
  static observedAttributes = ['estado'];

  connectedCallback() {
    this.mirada = this.querySelector('.acorde-nota__mirada');
    this.alMover = (evento) => this.mirar(evento);
    if (!QUIETO.matches) window.addEventListener('pointermove', this.alMover, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('pointermove', this.alMover);
    clearTimeout(this.vuelta);
  }

  attributeChangedCallback(_nombre, _antes, valor) {
    this.dataset.estado = ESTADOS.includes(valor) ? valor : 'reposo';
  }

  get estado() {
    return this.dataset.estado || 'reposo';
  }

  set estado(valor) {
    clearTimeout(this.vuelta);
    this.setAttribute('estado', valor);
  }

  /** Muestra un estado un momento y regresa al que tenía. */
  decir(estado, milisegundos = 1200) {
    const anterior = this.pendiente || this.estado;
    this.pendiente = anterior;
    clearTimeout(this.vuelta);
    this.setAttribute('estado', estado);
    this.vuelta = setTimeout(() => {
      this.pendiente = null;
      this.setAttribute('estado', anterior);
    }, milisegundos);
  }

  /** Mueve los ojos unos píxeles hacia el puntero. Un cálculo por cuadro como máximo. */
  mirar(evento) {
    if (this.esperando || !this.mirada) return;
    this.esperando = true;
    requestAnimationFrame(() => {
      this.esperando = false;
      const caja = this.getBoundingClientRect();
      if (caja.bottom < 0 || caja.top > innerHeight) return;
      const dx = evento.clientX - (caja.left + caja.width / 2);
      const dy = evento.clientY - (caja.top + caja.height * 0.72);
      const largo = Math.hypot(dx, dy) || 1;
      const alcance = Math.min(1, largo / 260);
      this.style.setProperty('--mx', `${((dx / largo) * 3.5 * alcance).toFixed(2)}px`);
      this.style.setProperty('--my', `${((dy / largo) * 3 * alcance).toFixed(2)}px`);
    });
  }
}

if (!customElements.get('acorde-nota')) {
  customElements.define('acorde-nota', AcordeNota);
}
